import styled from '@emotion/styled';
import { breakpoints, spacing } from '@naf/theme';

export const Wrapper = styled.div`
  @media (max-width: ${breakpoints.s}) {
    margin-top: ${spacing.space24};
  }
`;
